export default __webpack_public_path__ + "static/media/titan-logo.06183db1.png";